import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import * as _ from 'lodash';

import LifeEventRow from './LifeEventRow';

class LifeEventsHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      events: [],
    };
  }

  componentWillMount() {
    this.eventsRef = firebase.database()
      .ref(`/clients/${this.props.client}/driver/lifeEvents/${this.props.driver.$key}`);

    this.eventsListener = this.eventsRef.on('value', (eventsSnapshot) => {
      this.setState({
        events: _.orderBy(_.map(eventsSnapshot.val(), (event, key) => ({
          $key: key,
          startedAt: Number(key),
          ...event,
        })), ['startedAt'], ['desc']),
      });
    });
  }

  componentWillUnmount() {
    this.eventsRef.off('value', this.eventsListener);
  }

  getEventsRows() {
    const rows = this.state.events.map((event, index) => (
      <LifeEventRow key={event.$key} event={event} isLast={index === 0} />
    ));

    return rows;
  }

  render() {
    return (
      <table className="mm-popup--events-table">
        <thead>
          <tr>
            <th>Iniciado em</th>
            <th>Evento</th>
            <th className="align-right">Duração</th>
            <th className="align-right">Ac. Trab</th>
            <th className="align-right">Ac. Folga</th>
          </tr>
        </thead>
        <tbody>
          {this.getEventsRows()}
        </tbody>
      </table>
    );
  }
}

LifeEventsHistory.propTypes = {
  driver: PropTypes.object.isRequired,
  client: PropTypes.string.isRequired,
};

const mapStateToProps = store => ({
  client: store.authState.currentUser.client,
});

export default connect(mapStateToProps, null)(LifeEventsHistory);



// WEBPACK FOOTER //
// ./src/Driver/LifeEventsHistory.js